import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../../darkmode/DarkModeContext';
import { useNavigate } from 'react-router-dom';

const Section = () => {
  const { isDarkMode } = useDarkMode();
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      id: 'slide-1',
      promo: 'Promo Terbatas',
      title: 'IP Allocation & ASN Services',
      description: "Layanan IP dan ASN kami memungkinkan pengelolaan alamat IP dan identifikasi yang unik bagi perusahaan dan bisnis, memberikan kontrol penuh atas penggunaan internet dan infrastruktur jaringan mereka.",
      icon: '/image/ip_alocation.png',
      discountSub: 'untuk pelanggan baru!',
      backgroundImage: 'https://telnet.net.id/assets/bg.png',
      overlay: 'linear-gradient(135deg,  rgba(255, 255, 255, 0.8) 0%, rgba(224, 249, 218, 0.9) 100%)',
      className: 'slide-1',
      ctaText: 'Daftar Sekarang',
      action: () => { navigate('/register'); },
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative mb-16 overflow-hidden w-full min-h-screen md:min-h-[64vh] flex items-center">
      {slides.map((slide, index) => (
        <div 
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'} flex items-center w-full h-full`}
          style={{
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* Overlay gradient */}
          <div className="absolute inset-0" style={{ background: slide.overlay }}></div>
          
          {/* Konten */}
          <div className="container mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between relative z-10 pt-16 md:pt-0">
            {/* Teks konten - kiri */}
            <div className="w-full md:w-1/2 mb-6 md:mb-0 text-center md:text-left text-black py-8 md:py-0">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
                {slide.title}
              </h1>
              
              <p className="text-base sm:text-lg md:text-xl mb-6 opacity-90 max-w-md mx-auto md:mx-0 leading-relaxed">
                {slide.description}
              </p>

              {/* CTA Button */}
              <div className="mt-6">
                <button 
                  onClick={slide.action}
                  className="bg-green-400 hover:bg-green-500 text-black font-bold py-3 px-6 sm:px-8 rounded-full transition duration-300 transform hover:scale-105 shadow-lg text-sm sm:text-base"
                >
                  {slide.ctaText}
                </button>
              </div>
            </div>
              
            {/* Gambar - kanan */}
            <div className="w-full md:w-1/2 flex justify-center mb-2 md:mt-0">
            {slide.icon && (
                <img
                src={slide.icon}
                alt={slide.promo}
                className="max-w-full h-auto object-contain animate-float cursor-zoom-in"
                style={{ maxWidth: '600px' }} // ubah maxWidth sesuai keinginan Anda
                />
            )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Section;